var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4"},_vm._l((_vm.items),function(item){return _c('TableItem',{key:item.id,attrs:{"item":item,"access_type":_vm.user_access_type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }